import axios from 'axios'

const BASE = import.meta.env.VITE_API_URL || '/api'
export const api = axios.create({ baseURL: BASE })

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token')
  if (token) cfg.headers.Authorization = `Bearer ${token}`

  // SUPER_ADMIN: send active company context header
  const activeCompanyId = localStorage.getItem('activeCompanyId')
  if (activeCompanyId) {
    cfg.headers['X-Company-Id'] = activeCompanyId
  } else {
    // Explicitly send empty string so backend knows SUPER_ADMIN has no active company
    // (only needed if SUPER_ADMIN — let backend decide based on JWT role)
    delete cfg.headers['X-Company-Id']
  }

  return cfg
})
api.interceptors.response.use(r => r, e => {
  if (e.response?.status === 401) { localStorage.removeItem('token'); localStorage.removeItem('user'); window.location.href = '/login' }
  return Promise.reject(e)
})

export const ASSET_TYPE_LABELS: Record<string,string> = { LAPTOP:'Laptop', MONITOR:'Monitor', PHONE:'Phone', PRINTER:'Printer', NETWORK:'Network', OTHER:'Other' }
export const ASSET_STATUS_LABELS: Record<string,string> = { IN_USE:'In Use', AVAILABLE:'Available', MAINTENANCE:'Maintenance', RETIRED:'Retired', LOST:'Lost' }
export const STATUS_COLORS: Record<string,string> = {
  IN_USE:      'bg-blue-100 text-blue-700',
  AVAILABLE:   'bg-green-100 text-green-700',
  MAINTENANCE: 'bg-yellow-100 text-yellow-700',
  RETIRED:     'bg-gray-100 text-gray-500',
  LOST:        'bg-red-100 text-red-700',
}
export const DELIVERY_STATUS_OPTIONS = ['ยังไม่มีใบส่งมอบ','มีใบส่งมอบ','รอลงนาม','เสร็จสิ้น']
